import { connect, disconnect } from './echo';
import {
  requestNotificationPermission,
  showBrowserNotification,
} from '@/utilities/notification';

const listenNotification = (store) => {
  const echo = connect();
  const channel = echo.channel('notifications');

  const handleNotification = (data) => {
    const parsed = typeof data === 'string' ? JSON.parse(data) : data;
    const user = store.getters['auth/user'];
    const userRole = user?.roles?.[0]?.name || '';
    const userChannel = user?.VTWEG || '';

    const notifRole = parsed.role || '';
    const notifChannel = parsed.channel || '';

    const isForEveryone =
      notifRole === 'Todos' &&
      (notifChannel.includes('DT') || notifChannel.includes('PR'));

    const roleMatches =
      notifRole.includes(userRole) || notifRole.includes('Todos');

    const channelMatches = notifChannel.includes(userChannel);

    if (isForEveryone || (roleMatches && channelMatches)) {
      store.commit('userNotification/ADD_REALTIME_NOTIFICATION', parsed);
      showBrowserNotification(parsed);
    }
  };

  channel.listen('.user-notification.published', handleNotification);
  channel.listen('.notification.reached-publish-date', handleNotification);

  return channel;
};

export default {
  install(Vue, { store }) {
    Vue.prototype.$notifications = {
      listenNotification,
    };

    store.watch(
      (state, getters) => getters['auth/authenticated'],
      (authenticated) => {
        if (authenticated) {
          requestNotificationPermission();
          listenNotification(store);
        } else {
          disconnect();
        }
      },
      { immediate: true }
    );
  },
};

export { listenNotification };
